var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-data _margin-bottom-20"},[_vm._v(" "+_vm._s(_vm.map[_vm.paymentId])+" "),_c('uiv-btn',{attrs:{"type":"link","size":"xs"},on:{"click":function($event){return _vm.$emit('onEdit')}}},[_vm._v("Change")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }